export default __webpack_public_path__ + "static/media/Diane.67583b28.png";